<template>
  <div class="add-drug-container">
    <el-dialog :title="nameTitle" :visible.sync="dialogVisible" width="80%" top="5vh" v-loading="loading"
      class="add-drug-dialog" @close="handleClose"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
      :modal-append-to-body="false"
      :append-to-body="false"
      :show-close="false">

      <template slot="title">
        <div class="dialog-header">
          <span class="dialog-header-title">{{ nameTitle }}</span>
          <div class="header-buttons">
            <el-button type="text" @click="dialogVisible = false" icon="el-icon-close" class="close-button"></el-button>
          </div>
        </div>
      </template>

      <div class="dialog-content">
        <div class="top-section">
          <div class="form-top">
            <el-form :model="form" ref="topForm" label-width="120px" size="small"
              :rules="formRules" :disabled="formDisabled || mode === 'view'">

              <div class="tab-content-fixed-height">
                <!-- 只有一个标签页，直接嵌入 BasicInfo -->
                <basic-info ref="basicInfo" :form="form"
                  :form-disabled="formDisabled || mode === 'view'" :mode="mode"
                  @update="handleFormUpdate">
                </basic-info>
              </div>
            </el-form>
          </div>
        </div>
      </div>

      <div slot="footer" class="dialog-footer" v-if="mode !== 'view'">
        <el-button size="mini" type="primary" @click="submitForm">
          {{ mode === 'edit' ? '修改保存' : '确认添加' }}
        </el-button>
        <el-button size="mini" @click="dialogVisible = false">关闭</el-button>
      </div>
      <div slot="footer" class="dialog-footer" v-else>
        <el-button size="mini" @click="dialogVisible = false">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import BasicInfo from './F2.vue';
import { addProduction, updateProduction, getProduction } from "@/api/Outpatient/eisai.js";

export default {
  name: 'AddDrugDialog',
  components: { BasicInfo },
  data() {
    return {
      dialogVisible: false,
      nameTitle: '',
      mode: 'add', // 'add' | 'edit' | 'view'
      loading: false,
      form: {
        // 与接口参数完全对应
        applicableObject: '',
        businessLicense: '',
        businessLicensePeriod: '', // 营业执照有效期
        contactNumber: '',
        contacts: '',
        creditCode: '',
        email: '',
        fax: '',
        gmp: '', // gmp证书号
        gmpPeriod: '', // gmp证书有效期
        hygieneValidityPeriod: '', // 卫生有效期
        hygienicLicense: '', // 卫生许可证
        manufacturerName: '', // 生产厂商名称
        origin: '', // 产地
        periodValidity: '', // 有效期
        postalCode: '', // 邮政编码
        productionLicense: '', // 生产许可证
        productionValidityPeriod: '', // 生产许可证有效期
        region: '', // 所属地域
        remake: '', // 备注
        status: 1, // 状态（1启用，0禁用）
        url: '' // 网址
      },
      formRules: {
        manufacturerName: [{ required: true, message: '请输入厂商名称', trigger: 'blur' }],
        contactNumber: [{ required: true, message: '请输入联系电话', trigger: 'blur' }]
      },
      formDisabled: false,
    };
  },
  watch: {
    // 如果后续需要根据模式调整禁用状态等，可在此添加
  },
  methods: {
    // 打开对话框
    async openAddModel(param) {
      this.dialogVisible = true;
      this.nameTitle = param.label || '新增生产厂商';
      this.mode = param.mode || 'add';
      try {
        this.loading = true;
        if ((this.mode === 'edit' || this.mode === 'view') && param.id) {
          await this.loadEditData(param.id);
        } else {
          this.resetForm();
        }
      } catch (error) {
        console.error('加载数据失败:', error);
        this.$message.error('打开对话框失败');
      } finally {
        this.loading = false;
      }
    },

    // 加载编辑/查看数据
    // loadEditData 方法中的关键修改部分
    async loadEditData(id) {
      try {
        this.loading = true;
        let res = await getProduction({ id: id });
        if (res.code === 200) {
          const data = res.data;
          this.form = {
            id: data.id,
            applicableObject: data.applicableObject || '',
            businessLicense: data.businessLicense || '',
            businessLicensePeriod: data.businessLicensePeriod || data.licenseValidity || '',
            contactNumber: data.contactNumber || '',
            contacts: data.contacts || '',
            creditCode: data.creditCode || '',
            email: data.email || '',
            fax: data.fax || '',
            gmp: data.gmp || '',
            gmpPeriod: data.gmpPeriod || '',
            hygieneValidityPeriod: data.hygieneValidityPeriod || '',
            hygienicLicense: data.hygienicLicense || '',
            manufacturerName: data.manufacturerName || '',
            origin: data.origin || '',
            periodValidity: data.periodValidity || '',
            postalCode: data.postalCode || '',
            productionLicense: data.productionLicense || '',
            productionValidityPeriod: data.productionValidityPeriod || '',
            region: data.region || '',
            remake: data.remake || '',
            // ★★★ 关键修复：将 status 转为数字类型 ★★★
            status: data.status !== undefined && data.status !== null ? Number(data.status) : 1,
            url: data.url || ''
          };
        } else {
          this.$message.error(res.message || '加载数据失败');
        }
      } catch (error) {
        console.error('加载编辑数据失败:', error);
        this.$message.error('加载数据失败');
      } finally {
        this.loading = false;
      }
    },

    // 表单更新（子组件触发）
    handleFormUpdate(updatedData) {
      this.form = { ...this.form, ...updatedData };
    },

    // 提交表单
    async submitForm() {
      this.$refs.topForm.validate(async (valid) => {
        if (!valid) {
          this.$message.error('请将必填信息填写完毕！');
          return;
        }
        try {
          this.loading = true;
          // 子组件可能还有额外校验，这里调用子组件的 validateForm 方法
          if (this.$refs.basicInfo && this.$refs.basicInfo.validateForm) {
            try {
              await this.$refs.basicInfo.validateForm();
            } catch (error) {
              console.error('子组件验证失败:', error);
              this.$message.error('请填写完整的必填信息');
              this.loading = false;
              return;
            }
          }
          // 构建提交数据
          const submitData = { ...this.form };
          // 确保状态为数字
          submitData.status = Number(submitData.status);
		  submitData.id = this.form.id;
          let response;
          if (this.mode === 'add') {
            response = await addProduction(submitData);
          } else {
            response = await updateProduction(submitData);
          }
          if (response.code === 200) {
            this.$message.success(this.mode === 'add' ? '新增成功' : '保存成功');
            this.dialogVisible = false;
            this.$emit('refresh');
          } else {
            this.$message.error(response.message);
          }
        } catch (error) {
          console.error('保存失败:', error);
          this.$message.error('保存失败: ' + error.message);
        } finally {
          this.loading = false;
        }
      });
    },

    // 重置表单
    resetForm() {
      this.form = {
        applicableObject: '',
        businessLicense: '',
        businessLicensePeriod: '',
        contactNumber: '',
        contacts: '',
        creditCode: '',
        email: '',
        fax: '',
        gmp: '',
        gmpPeriod: '',
        hygieneValidityPeriod: '',
        hygienicLicense: '',
        manufacturerName: '',
        origin: '',
        periodValidity: '',
        postalCode: '',
        productionLicense: '',
        productionValidityPeriod: '',
        region: '',
        remake: '',
        status: 1,
        url: ''
      };
      this.$nextTick(() => {
        if (this.$refs.topForm) {
          this.$refs.topForm.clearValidate();
        }
      });
    },

    // 关闭对话框
    handleClose() {
      this.resetForm();
      this.dialogVisible = false;
      this.$emit('close');
    },

    // 重置校验（供父组件调用）
    resetAllValidation() {
      if (this.$refs.topForm) {
        this.$refs.topForm.clearValidate();
      }
      if (this.$refs.basicInfo && this.$refs.basicInfo.resetValidation) {
        this.$refs.basicInfo.resetValidation();
      }
    }
  }
};
</script>

<style lang="less" scoped>
.add-drug-container {
  ::v-deep * {
    box-sizing: border-box;
  }
  ::v-deep .el-dialog {
    border-radius: 8px !important;
    overflow: hidden;
    height: 80vh;
    display: flex;
    flex-direction: column;
    .el-dialog__header {
      padding: 12px 20px 12px 20px !important;
      background: linear-gradient(135deg, #00557f 0%, #ebfaff 100%);
      border-top-left-radius: 8px;
      border-top-right-radius: 8px;
      flex-shrink: 0;
      position: relative;
      .dialog-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        .dialog-header-title {
          color: #fff;
          font-size: 16px;
          font-weight: bold;
        }
        .header-buttons {
          .close-button {
            color: #fff;
            padding: 0;
            width: 20px;
            height: 20px;
            font-size: 16px;
          }
        }
      }
    }
    .el-dialog__body {
      padding: 0 !important;
      flex: 1;
      overflow: hidden;
      display: flex;
      flex-direction: column;
    }
    .dialog-footer {
      flex-shrink: 0;
    }
  }

  .dialog-content {
    display: flex;
    flex-direction: column;
    height: 100%;
    overflow: hidden;
    .top-section {
      flex: 1;
      display: flex;
      flex-direction: column;
      min-height: 0;
      overflow: hidden;
      .form-top {
        flex: 1;
        display: flex;
        flex-direction: column;
        min-height: 0;
        overflow: hidden;
        .el-form {
          width: 100%;
          height: 100%;
          display: flex;
          flex-direction: column;
          min-height: 0;
          .tab-content-fixed-height {
            flex: 1;
            display: flex;
            flex-direction: column;
            min-height: 0;
            overflow: hidden;
            // BasicInfo 组件直接占据整个区域
            .basic-info {
              flex: 1;
              display: flex;
              flex-direction: column;
              min-height: 0;
              overflow: hidden;
            }
          }
        }
      }
    }
  }
  .dialog-footer {
    padding: 12px;
    border-top: 1px solid #ebeef5;
    text-align: right;
    .el-button {
      font-size: 12px;
    }
  }
}
</style>